import { Collection, Select, MultilineInput, TableBuilder, NumberInput, TextInput, Link, Span } from "@tblabs/truffle";
import { ProductSelector } from "../../../../Components/ProductSelector";
import { BasketItemType } from "../../../../Models/Basket/BasketItemType";
import { RentBasketItem } from "../../../../Models/Basket/RentBasketItem";
import { SaleBasketItem } from "../../../../Models/Basket/SaleBasketItem";
import { RawProductFromWebsite } from "../../../../Models/ProductsCatalog/RawProduct";
import { AddToBasketStep } from "../../../../Steps/AddToBasket/AddToBasketStep";
import { Step } from "../../../../Steps/Step/Step";
import { TimeUtils } from "../../../../Utils/TimeUtils";
import { Entry } from "./Entry";
import { WebsiteProductConverter } from "./ProductConverter";
import { XButton } from "../../../../Components/Utils/XButton";
import { Icons } from "../../../../Components/Utils/Icons";
import { PaymentStep } from "../../../../Steps/Payment/PaymentStep";
import { TabsV2 } from "../../../../Components/Utils/Tabs";
import { PaymentFormNames } from "../../../../Models/Payment/PaymentForm";
import { Box } from "../../../../Components/Utils/Box";
import { DateSlider } from "../../../../Components/Utils/DateSlider";
import { XPrimaryButton } from "../../../../Components/Utils/XPrimaryButton";
import { BitcoinPriceProvider } from "../../../../Steps/Payment/Services/BitcoinPriceProvider";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";


export class AddToBasketEntryEditBox extends Entry<Step<any>>
{
    constructor(step: AddToBasketStep, steps: Collection<Step<any>>, productsInfo: RawProductFromWebsite[])
    {
        super(step, steps, []);

        this.AddInput("Stan", new Select(step.Data.State, step.AllStates));
        this.AddInput("Powód odrzucenia", new MultilineInput(step.Data.RejectionReason).Rows(4).Placeholder("Powód odrzucenia"));

        this.Content.Append(
            new TableBuilder(step.Data.BasketItems)
                .AddColumn("Typ", item => new Span(item.Type).Bold())
                .AddColumn("Produkt", item => new ProductSelector(productsInfo, item))
                .AddColumn("Ilość", item => new NumberInput(item.Quantity).Width(54).Min(1))
                .AddColumn("Cena za całość", item => new NumberInput(item.TotalPrice).Width(72).Min(0).Step(10))
                .AddColumn("Numer seryjny", item => new TextInput(item.ProductSerialNumber))
                .AddColumn("", item => new Link("✖️").OnClick(() => step.Data.BasketItems.Remove(item)))
                .Build()
                .FontSize(12),

            new XButton("light", "wynajem", Icons.Plus, () =>
            {
                step.Data.BasketItems.Add(new RentBasketItem({
                    Type: BasketItemType.Rent,
                    ProductInfo: WebsiteProductConverter.ToBasketProductInfo(productsInfo[0]),
                    Option: WebsiteProductConverter.ToBasketProductOption(productsInfo[0].Options.List[0]),
                    Quantity: 1,
                    TotalPrice: 0,
                    ProductSerialNumber: "",
                    From: new Date(),
                    To: new Date(),
                    Deposit: 300,
                }));
            }),

            new XButton("light", "sprzedaż", Icons.Plus, () =>
            {
                step.Data.BasketItems.Add(new SaleBasketItem({
                    Type: BasketItemType.Rent,
                    ProductInfo: WebsiteProductConverter.ToBasketProductInfo(productsInfo[0]),
                    Option: WebsiteProductConverter.ToBasketProductOption(productsInfo[0].Options.List[0]),
                    Quantity: 1,
                    TotalPrice: 0,
                    ProductSerialNumber: "",
                }));
            }),
        );

        this.SetTitle(step.GetFullTitle(), step.Data.State.value + ", do " + TimeUtils.FormattedDateTime(step.Timeout));
    }
}

// TODO: to na kiedy indziej
export class PaymentEntryEditBox extends Entry<Step<any>>
{
    constructor(step: PaymentStep, steps: Collection<Step<any>>)
    {
        super(step, steps, []);
        this.SetTitle(step.GetFullTitle(), step.Data.State.value + ", do " + TimeUtils.FormattedDateTime(step.Timeout));

        this.AddInput("Stan", new Select(step.Data.State, step.AllStates));
        this.AddInput("Forma płatności", new Select(step.Data.Form, PaymentFormNames));
        // this.AddInput("Powód anulowania", new MultilineInput(step.Data.CancellationReason).Rows(4).Placeholder("Powód odrzucenia"));

        this.Content.Append(
            new TabsV2()
                .Add(Icons.Money, "Dane do przelewu", () => new Table([], [
                    ["Tytułem", new TextInput(step.Data.Title)],
                    ["Numer konta", new TextInput(step.Data.AccountNumber)],
                    ["Kwota", new NumberInput(step.Data.Amount)],
                    ["Waluta", new TextInput(step.Data.Currency)],
                    ["Płatne do", new DateSlider(step.Data.Deadline)],
                    ["Data wpłaty", new DateSlider(step.Data.WhenPaid)],
                    ["Komentarz", new TextInput(step.Data.Comment)],
                ]))
                .Add(Icons.Bitcoin, "Kryptowaluta", () => new Box(
                    new XPrimaryButton("Pobierz kurs BTC", Icons.Plus, async () =>
                    {
                        const bitcoinPriceProvider = new BitcoinPriceProvider();
                        await bitcoinPriceProvider.Update();
                    })
                ))
        );
    }
}
